// @ts-strict-ignore
import React, { memo } from 'react'
import { classList } from 'services/styles'
import { makeStyles } from 'tss-react/mui'

interface ITagProps extends React.HTMLProps<HTMLSpanElement> {
  disableSeparator?: boolean
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
  },
  noSeparator: {
    marginRight: theme.spacing(1),
    '&::after': {
      display: 'none !important',
    },
  },
}))

function Tag({ children, className, disableSeparator, ...restProps }: ITagProps) {
  const { classes } = useStyles()

  return (
    <span className={classList(className, classes.container, disableSeparator ? classes.noSeparator : null)} {...restProps}>
      {children}
    </span>
  )
}

export default memo(Tag)
